/* ==== PO1 (2026-10-02): THE PHONE — PORTRAIT IS THE JOURNAL, LANDSCAPE THE MAP
   notes/phone-design.md is the design and its reasoning; this is its
   hand. Tommy: "if you just have the journal when you land on portrait,
   then that's a version of the site that's fine to use ... if you then do
   turn off portrait lock and go landscape, we can redraw to show the map
   instead, collapse the journal down", and from the map, "render the
   journal in the other orientation over the top of it ... so you just
   turn the phone".

   So the way the phone is HELD picks the view:
     upright    the Journal, open (books.js never lets it shut to nothing
                there), or the Field Book if it was brought up from the map;
     on its side  the map (engine.js lays the plate across the glass), the
                two books as spines at its foot. A spine tapped opens its
                book drawn for the phone upright, so it lies sideways over
                the dimmed map: the book itself says "turn me".
   A turn on to the side puts any book down (RS1 keeps its place); a turn
   upright with nothing out brings the Journal back where it was left.

   WHICH WAY IS HELD is the screen's own orientation, not the window's
   shape: a keyboard or a split screen makes a portrait window wide, and
   the bar sliding in and out is a resize that is not a turn.

   THE SIDEWAYS BOOK. Both books live in one frame (`.phone-books`, made
   here, phone only, so a desk never has it), a size container that is the
   glass upright and, on its side with a book out, the glass's height wide
   and its width high, turned a quarter onto the screen. The books' phone
   rules (styles.css, PO1) are written in the frame's own units, so the
   book is laid exactly as it is upright, and the browser hit-tests the
   turned box itself. What does not come for free is the measures books.js
   pages by (a box's rect, a line's rects): inside the turned frame they are
   answered in the frame's own axes, as the page would have them upright.

   Only on html.phone (base.njk: every touch phone, PS1). Anywhere else
   this file returns on its first line and nothing is patched. ==== */
(function () {
'use strict';
var H = document.documentElement;
if (!/\bphone\b/.test(H.className)) return;

/* ---- which way the phone is held ------------------------------------ */
/* LA2 (2026-10-03): THE WINDOW'S OWN SHAPE, AS A MEDIA QUERY. It was the
   screen's orientation, read first because a keyboard or a bar can change
   the window without a turn. Tommy's screen recording of his iPhone showed
   what that cost: iOS reports the screen's orientation AFTER it has laid
   the page out in the new shape, so for a frame or two the new shape was
   drawn with the old one's page (a sideways book, small, at the top of the
   upright glass). The window's shape is what the browser lays the page out
   by, and its media query's change is reported before that frame is
   painted; the styles (styles.css, `@media (orientation: ...)`) read the
   same fact at the same moment, so the first frame of the new shape is
   already right. On a phone a keyboard never makes an upright window wide
   or a wide one tall, and a bar sliding changes neither. */
var MQ = window.matchMedia('(orientation: landscape)');
function land() { return MQ.matches; }
/* turned anticlockwise (its head to the left) or clockwise. iOS's own
   window.orientation is the one every WebKit has said the same way for
   years (90: head to the left); the screen's angle is the fallback, and
   with neither the commoner turn, anticlockwise, is assumed. */
function anticlockwise() {
  if (typeof window.orientation === 'number') return window.orientation !== -90;
  var a = screen.orientation && screen.orientation.angle;
  return a !== 270 && a !== -90;
}
/* ==== ST1 (2026-10-03): A BOOK PUT AWAY BY A TURN IS STOWED, NOT SHUT.
   Tommy's second recording: turned back upright, the Journal came back on
   the wrong page for two frames and then jumped to the right one, because
   it had been shut and was being opened afresh (dealt again while its
   pictures decoded). His model is "putting the book away" and "pulling the
   book back out", so it is put away OPEN: on its side the book an upright
   reading had out stays open at its page and is simply not drawn
   (`.stowed`); turned upright it is drawn again, exactly as it was. Its
   own spine, or a bench mark tapped on the map, brings it out sideways
   instead; the other book's spine puts it away for good (one open book).
   A hand on the map does not shut it (books.js reads `RoomPhone.stowed`).
   `openBook()` is the book that is OUT: never a stowed one. ==== */
var stowed = null;
function openBook() {
  var b = document.querySelector('.book[data-open="true"]');
  return b && b !== stowed ? b : null;
}
function stow(b) {
  if (stowed === b) return;
  if (stowed) stowed.classList.remove('stowed');
  stowed = b || null;
  if (stowed) stowed.classList.add('stowed');
}
/* out again: the stowed book is the open one once more */
function unstow() { if (stowed) { stow(null); classes(); return true; } return false; }
/* upright with nothing out: the stowed book, or the Journal where it was */
function bringOut() {
  if (unstow()) return;
  var B = window.RoomBooks;
  if (B && B.resumeJournal) B.resumeJournal();
}

/* ==== RU1 (2026-10-03): UPRIGHT, THE ROOM IS THE ROOM. Tommy, of the
   portrait terminal's close popping back into the Journal: '"flip to
   journal" should stop once we've folded the map ... the room theoretically
   works portrait or landscape, right?', and he took the proposal: once the
   sheet is folded (or the reader is standing, or at the machine) the phone
   held upright shows the ROOM, laid out for the upright glass, not the
   Journal; the books are reached from the desk as on its side, and the
   terminal's close leaves the reader in the room. The map itself still
   needs the phone on its side, so unfolding it upright brings the Journal
   back (and the map lies turned under it, LA1).
   The cost, agreed: with the sheet folded a turn lays the room out again
   for the new shape (there is no book to put away, so the picture is the
   only thing that changes). `world()` is "not at the map"; `uproom` is the
   class that holds the canvas upright (styles.css). ==== */
function world() {
  var R = window.Room, O = window.RoomObjects;
  if (!R || !booted) return false;
  return !!((R.inRoom && R.inRoom()) || (R.lapUp && R.lapUp()) ||
            (R.folded && R.folded() > 0.0005 && !(R.unfolding && R.unfolding())) || (O && O.foldGrab));   /* UF1 */
}
var uproom = false;

/* ---- TM1 (2026-10-02): THE TERMINAL IS A PORTRAIT PAGE ----------------
   Tommy agreed the proposal: landscape is the world, portrait is reading
   and typing. A phone's keyboard on its side leaves about 150 px above it,
   and the screen on the laptop is a 620 px panel. So:
     on its side, a tap on the laptop turns to it as at a desk, and when
       the turn has landed the screen LIFTS OFF as a page lying sideways
       over the dimmed glass (as a book does: it says "turn me"); a tap off
       it turns away from the machine;
     upright, it is the whole glass above the keyboard, and a tap on it
       types; its close turns away, and upright with nothing open is the
       Journal;
     turned back on to its side, the page goes back on to the laptop's
       screen in the room (where an agent's typing after `link` can be
       watched), and a tap on that screen lifts it off again.
   `termOut` is the page being out. terminal.js `page()` moves the screen
   into the frame and back. */
var termOut = false, termAsked = false, fitted = false;
function termEl() { return document.querySelector('.tm'); }
function termUp() {
  var R = window.Room;
  return !!(R && R.lapUp && R.cam && R.cam.lapWant > 0.5 && window.RoomTerm && RoomTerm.up && RoomTerm.up());
}
function out() { return !!openBook() || termOut; }
function setTerm(on) {
  on = !!on;
  if (on === termOut) return;
  var T = window.RoomTerm;
  if (on && !(T && T.page && frame)) return;
  termOut = on;
  if (!on) fitted = false;           /* page(false) clears the fit itself */
  if (T && T.page) T.page(on, frame);
  /* KB1: upright the page comes up with the keyboard (primeKeys) */
  if (on && !cur && T.focus) { T.focus(); clearTimeout(primeT); }
  classes();
}
/* ==== KB1 (2026-10-04): UPRIGHT, THE TERMINAL OPENS WITH THE KEYBOARD UP.
   Tommy: "it probably should" (raise the keyboard on its own). iOS raises
   the keyboard only for a focus made inside the tap itself, and the page
   comes out about a second later, when the turn to the machine lands
   (watchTerm). So the tap on the machine focuses a hidden input at once
   (the keyboard comes up while the camera turns) and the page's own input
   takes the focus from it when it opens; the keyboard stays, because focus
   moves between two inputs. A turn that never lands lets it go. ==== */
var primer = null, primeT = 0;
function primeKeys() {
  if (cur) return;                                     /* on its side the page is not out */
  if (!primer) {
    primer = document.createElement('input');
    primer.type = 'text'; primer.tabIndex = -1; primer.autocomplete = 'off';
    primer.setAttribute('aria-hidden', 'true');
    primer.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;' +
                           'font-size:16px;border:0;padding:0;margin:0;pointer-events:none;';
    document.body.appendChild(primer);
  }
  try { primer.focus({ preventScroll: true }); } catch (e) { primer.focus(); }
  clearTimeout(primeT);
  primeT = setTimeout(function () { if (document.activeElement === primer) primer.blur(); }, 4000);
}
/* the page follows the machine: out when the turn to it lands (on its
   side), and put back whenever the reader has turned away from it */
function watchTerm() {
  if (!booted) return;
  if (!termUp()) {
    termAsked = false;
    if (termOut) {
      setTerm(false);
      if (!cur && !openBook() && !world()) bringOut();     /* RU1: in the room it is the room */
    }
    return;
  }
  if (!termAsked && !openBook() && (window.Room.cam.lap || 0) > 0.98) { termAsked = true; setTerm(true); }
}
/* upright the page is the glass above the keyboard: the visual viewport,
   which is what the keyboard shortens (the layout viewport is not) */
function fitTerm() {
  var el = termEl();
  if (!el) return;
  var v = window.visualViewport;
  if (!termOut || cur || !v) { if (fitted) { fitted = false; el.style.top = ''; el.style.height = ''; } return; }
  fitted = true; el.style.top = v.offsetTop + 'px'; el.style.height = v.height + 'px';
}
if (window.visualViewport) {
  visualViewport.addEventListener('resize', fitTerm);
  visualViewport.addEventListener('scroll', fitTerm);
}
/* AND NO FIELD ZOOMS THE PAGE WHEN IT TAKES THE KEYBOARD. iOS enlarges the
   page on to a focused field set under 16 px (the terminal's prompt, the
   cartouche's handle) and leaves it so; held at the page's own scale it
   does not. The page never zooms on a phone anyway (gestures, below). */
(function () {
  var vm = document.querySelector('meta[name="viewport"]');
  if (vm && !/maximum-scale/.test(vm.content)) vm.content += ', maximum-scale=1';
})();

/* ---- the frame ------------------------------------------------------ */
var frame = null;
function makeFrame() {
  var k = document.getElementById('key'), j = document.getElementById('journal');
  if (!k || !j || frame) return;
  frame = document.createElement('div');
  frame.className = 'phone-books';
  /* LA1: on the BODY, not in #canvas: the canvas is turned in portrait
     (placeCanvas) and the books are not */
  document.body.appendChild(frame);
  frame.appendChild(k); frame.appendChild(j);
  /* the quiet sign, on the contents' leaf, that the phone turns (the
     design's "hint"): the sheet drawn folded with a turn mark. A tap
     only gives it a nudge. */
  var leaf = j.querySelector('.journal-leaf--left');
  if (leaf) {
    var m = document.createElement('span');
    m.className = 'phone-turn';
    m.setAttribute('aria-hidden', 'true');
    m.innerHTML = '<svg viewBox="0 0 40 28" width="40" height="28">' +
      '<rect x="12.5" y="5.5" width="25" height="15" rx="1"/>' +
      '<path d="M16 15c3-4 6 1 9-2s5-3 9 0M16 10.5c2 1.5 4-1 7 0s4 2 6 0"/>' +
      '<rect x="3.5" y="3.5" width="6" height="11" rx="1"/>' +
      '<path d="M5 19.5a9 9 0 0 0 7.5 5"/><path d="M10.6 22.4l2 2.2-2.6 1"/></svg>';
    m.addEventListener('click', function () {
      m.classList.remove('nudge'); void m.offsetWidth; m.classList.add('nudge');
    });
    leaf.appendChild(m);
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', makeFrame, { once: true });
else makeFrame();

/* is the frame turned onto the glass now: on its side with a book (or the
   terminal's page) out that was brought out on its side */
function sideBook() { return land() && H.classList.contains('sidebook'); }

/* ---- the measures inside the turned frame --------------------------- */
/* page -> frame: the frame's own matrix (styles.css lays it, from the
   numbers vars() gives it), undone. A box turned a quarter is still a box,
   so its four corners carried back give the frame's box exactly. */
var inv = null, invKey = '';
function frameInv() {
  var t = getComputedStyle(frame).transform;
  if (t !== invKey) { invKey = t; inv = t && t !== 'none' ? new DOMMatrix(t).inverse() : null; }
  return inv;
}
function toFrame(r) {
  var m = frameInv();
  if (!m) return r;
  var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
  [[r.left, r.top], [r.right, r.top], [r.left, r.bottom], [r.right, r.bottom]].forEach(function (c) {
    var p = m.transformPoint(new DOMPoint(c[0], c[1]));
    x0 = Math.min(x0, p.x); x1 = Math.max(x1, p.x); y0 = Math.min(y0, p.y); y1 = Math.max(y1, p.y);
  });
  return new DOMRect(x0, y0, x1 - x0, y1 - y0);
}
function inFrame(n) { return frame && sideBook() && n && frame.contains(n); }
var gbcr = Element.prototype.getBoundingClientRect, gcr = Element.prototype.getClientRects;
var rbcr = Range.prototype.getBoundingClientRect, rcr = Range.prototype.getClientRects;
function list(rs) {
  var a = []; for (var i = 0; i < rs.length; i++) a.push(toFrame(rs[i]));
  a.item = function (i) { return a[i] || null; };
  return a;
}
Element.prototype.getBoundingClientRect = function () {
  var r = gbcr.call(this); return inFrame(this) ? toFrame(r) : r;
};
Element.prototype.getClientRects = function () {
  var r = gcr.call(this); return inFrame(this) ? list(r) : r;
};
Range.prototype.getBoundingClientRect = function () {
  var r = rbcr.call(this); return inFrame(this.startContainer) ? toFrame(r) : r;
};
Range.prototype.getClientRects = function () {
  var r = rcr.call(this); return inFrame(this.startContainer) ? list(r) : r;
};

/* ---- the view follows the phone ------------------------------------- */
/* ==== LA1 (2026-10-03): THE MAP IS ALWAYS LANDSCAPE, AND A TURN ONLY
   PUTS A BOOK AWAY OR BRINGS IT OUT. Tommy: "it feels like we may as well
   always draw the map in landscape underneath, as if the phone is
   landscape ... We just never allow you access to it in portrait mode.
   When you return landscape, it's as simple as putting the book away.
   Turning portrait is as simple as pulling the book back out", and "When
   you turn the phone from landscape to portrait, absolutely zero should
   change". His screen recording of TR1 showed why it had to be: the map
   laid out again for each shape during iOS's own turn, the book sliding
   away, and TR1's veil, half a second of near black, over all of it.
   So:
     - upright, #canvas keeps the size it has on its side (remembered from
       the last time the phone was on its side, or the screen's) and is
       turned a quarter the way the phone came from, centred (styles.css,
       from --land-w/--land-h/--crot): the engine sees the same glass either
       way up and never lays the map out for a turn, and the picture holds
       still on the glass. Nothing on it takes a hand upright;
     - a book (or the terminal's page) brought out on its side is laid at
       the glass's UPRIGHT size (remembered likewise) and turned on to the
       glass (--up-w/--up-h/--up-sc/--rot), so the turn upright stands the
       same page up with nothing dealt again (books.js TR1);
     - the map is dimmed under any book out, either way up;
     - the book put away or brought out by a turn goes or comes at once
       (`turning`: no motion of its own); iOS's turning of the window is
       the motion, and the one a page cannot stop.
   `cur` is the turn as this file last acted on it. ==== */
var cur = land(), booted = false;
var lastCcw = cur ? anticlockwise() : true;
function stored(k, ok) {
  try { var v = JSON.parse(localStorage.getItem(k) || 'null'); return v && ok(v) ? v : null; } catch (e) { return null; }
}
function store(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
function typing() { var a = document.activeElement; return !!(a && a.matches && a.matches('input,textarea')); }
var landSize = stored('tl-phone-land', function (v) { return v[0] > v[1] && v[1] > 200; });
var upSize = stored('tl-phone-up', function (v) { return v[0] > 200 && v[1] > 300 && v[1] > v[0]; });
/* the glass's two sizes, each kept while it is seen (not with the keyboard
   up), for the other way up */
function noteSizes(L) {
  if (typing()) return;
  if (L) {
    var c = document.getElementById('canvas');
    if (!c) return;
    var u = [c.clientWidth, c.clientHeight];
    if (u[0] > u[1] && u[1] > 200 && !(landSize && landSize[0] === u[0] && landSize[1] === u[1])) { landSize = u; store('tl-phone-land', u); }
  } else if (frame) {
    var f = [frame.clientWidth, frame.clientHeight];
    if (f[0] > 200 && f[1] > 300 && f[1] > f[0] && !(upSize && upSize[0] === f[0] && upSize[1] === f[1])) { upSize = f; store('tl-phone-up', f); }
  }
}
/* ==== GW1 (2026-10-05): THE GLASS IS THE WINDOW, NOT THE PAGE'S BOX.
   Found on a real iPhone 17 Pro (iOS 26.6, Chrome) through BrowserStack:
   on a first load on its side the page's own box (the initial containing
   block, so `#canvas`'s `inset: 0`) is the whole screen, 844 wide, while
   the window Chrome shows is 724 (innerWidth): the map was laid for 844
   and its east end and the corner lay off the glass, so it could not be
   folded (Tommy: "The first load can't be folded in landscape"). The box
   never changes after, so no resize and no ResizeObserver (VW1) say so; a
   reload has the two agree. So the canvas is sized to the window itself,
   read whenever anything moves (and four times a second, poll). ==== */
var glassKey = '';
function glass() {
  var w = window.innerWidth, h = window.innerHeight;
  if (!(w > 0 && h > 0)) return;
  var k = w + 'x' + h;
  if (k === glassKey) return;
  glassKey = k;
  H.style.setProperty('--gw', w + 'px'); H.style.setProperty('--gh', h + 'px');
}
var varsKey = '';
function vars() {
  var big = Math.max(screen.width, screen.height), small = Math.min(screen.width, screen.height);
  var L = landSize || [big, small], u = upSize || [small, Math.round(big * 0.78)];
  var sc = Math.min(1, L[0] / u[1], L[1] / u[0]);
  var ccw = cur ? anticlockwise() : lastCcw;
  var k = [L, u, sc.toFixed(4), ccw, lastCcw].join('|');
  if (k === varsKey) return;
  varsKey = k;
  var st = H.style;
  st.setProperty('--land-w', L[0] + 'px'); st.setProperty('--land-h', L[1] + 'px');
  st.setProperty('--up-w', u[0] + 'px'); st.setProperty('--up-h', u[1] + 'px');
  st.setProperty('--up-sc', sc.toFixed(4));
  st.setProperty('--rot', ccw ? '-90deg' : '90deg');
  st.setProperty('--crot', lastCcw ? '90deg' : '-90deg');
}

function classes() {
  var L = cur;
  if (L) lastCcw = anticlockwise();
  H.classList.toggle('land', L);
  H.classList.toggle('ccw', L && anticlockwise());
  H.classList.toggle('bookout', out());
  /* LA2: a book out on its side is one brought out on its side (a spine,
     the laptop): the Journal of an upright reading is put away by the turn,
     and is never drawn sideways on the way */
  H.classList.toggle('sidebook', L && out());
  /* EG4: a book opens only at the map (BK1), so off it (standing in the
     room, the sheet folded) the spines are not on the glass */
  var B = window.RoomBooks;
  H.classList.toggle('offmap', !!(L && B && B.mapView && !B.mapView()));
  /* RU1: upright off the map the canvas is the upright glass; the engine is
     told at once (its own resize waits 120 ms, and an unfold changes the
     canvas with no resize at all) */
  var ur = !L && world();
  if (ur !== uproom) {
    uproom = ur;
    H.classList.toggle('uproom', ur);
    if (window.Room && Room.refit) Room.refit();
  }
  glass();
  noteSizes(L);
  vars();
  fitTerm();
  return L;
}
/* the map view changes under the hand (a fold, standing up) with no event
   of its own: read four times a second while the phone is on its side */
/* ==== CR1 (2026-10-05): CHROME PUT THE PAGE IN THE WRONG PLACE: LOAD IT
   AGAIN. Tommy's iPhone 14 Pro (iOS 26.6, Chrome), on its side: the map
   nudged, the `#...` deleted from the address and Go. The page loaded
   right, then with no resize Chrome moved its window up under its own
   toolbar and out to the screen's left edge (a band of board along the
   right and the bottom), and widened it: the window said 793 x 337, the
   page's box 734 x 337, the visual viewport no offset and the safe area no
   top. Nothing a page can read says where the toolbar is, so it cannot be
   laid around; a reload is what puts it right (his own refresh did). A
   window WIDER than the page's box is only ever that state (the first-load
   fault, GW1, is the other way round). Not taller: Safari, and Chrome on
   Android, tuck their bar away on its side and make the window taller than
   the box with nothing wrong. Held for three polls it reloads the page, at
   most once a minute (sessionStorage; without it, never), and if the same
   state is back within the minute the reload did not help, so it gives up
   for the visit. Tommy: "detect it and reload ... there could be multiple
   routes into this bug". ==== */
var astrayN = 0;
function astray() {
  var d = document.documentElement;
  if (H.classList.contains('turning') || typing()) { astrayN = 0; return; }
  if (window.innerWidth > d.clientWidth + 2) astrayN++;
  else astrayN = 0;
  if (astrayN < 3) return;
  astrayN = 0;
  try {
    if (sessionStorage.getItem('tl-astray-off')) return;
    var t = +sessionStorage.getItem('tl-astray') || 0;
    if (Date.now() - t < 60000) { sessionStorage.setItem('tl-astray-off', '1'); return; }
    sessionStorage.setItem('tl-astray', String(Date.now()));
  } catch (e) { return; }
  location.reload();
}
function poll() {
  astray();
  watchTerm(); classes();
  /* RU1: upright, back at the map (the sheet unfolded, the machine left)
     with nothing out: the Journal, as a turn upright gives it */
  if (booted && !cur && !out() && !uproom && window.RoomBooks) bringOut();
}
setInterval(poll, 250);

/* the turn: the window's shape has changed */
var turnT = 0;
function turn() {
  var L = land();
  if (!booted) { cur = L; classes(); return; }
  if (L === cur) { classes(); return; }
  sw = null; tp = null; downs.clear();     /* a finger down through the turn is let go */
  H.classList.add('turning');
  cur = L;
  /* on to the side: the map, any book put down by its own close (RS1 keeps
     its place). Upright: the book that lay sideways stands up as it is;
     with none, the Journal comes back where it was left (TM1: at the
     machine, the terminal's page) */
  var B = window.RoomBooks;
  if (B) {
    if (L) { if (openBook()) stow(openBook()); setTerm(false); }
    else if (!out()) { if (termUp()) setTerm(true); else if (!world()) bringOut(); }
  }
  var wasRoom = uproom;
  classes();
  /* RU1: the room laid out for the new shape at once (the map's canvas is
     the same size either way up and needs nothing) */
  if ((wasRoom || uproom || (L && world())) && window.Room && Room.refit) Room.refit();
  clearTimeout(turnT);
  turnT = setTimeout(function () { H.classList.remove('turning'); }, 120);
}
if (MQ.addEventListener) MQ.addEventListener('change', turn); else if (MQ.addListener) MQ.addListener(turn);
/* a bar sliding, the other way on its side: the numbers, not a turn */
window.addEventListener('resize', turn);
if (screen.orientation && screen.orientation.addEventListener) screen.orientation.addEventListener('change', function () { classes(); });
window.addEventListener('orientationchange', function () { classes(); });
classes();

/* ==== JL1 (2026-10-04): UPRIGHT, THE JOURNAL IS THE FIRST THING SEEN.
   Tommy: "i don't love the first load in portrait, you get empty map and
   then journal, could we launch the journal earlier in portrait (the
   default way people will hit our site) so you don't ever see the ugly map
   behind?" The Journal waited for READY (~800 ms on the bench), so the
   first desk, then the turned blank sheet, then the inked map showed
   first. Now books.js calls this at the end of its init, which the engine
   runs in the task that lands frame 1: the Journal is out in that same
   frame, over the map dimmed as ever. Before frame 1 the first desk is a
   blank Journal page upright (styles.css JL1), so nothing but the page is
   ever on the glass. An essay's own link opens in books.js's init before
   this, so the boot holds the books still (`turning`) from the start: the
   page is there, not opening. */
if (!cur) H.classList.add('turning');
function booksIn() {
  var B = window.RoomBooks;
  if (!land() && !openBook() && !termUp() && B && B.resumeJournal) B.resumeJournal();
  classes();
  setTimeout(function () { H.classList.remove('turning'); }, 120);
}
/* BOOT: the engine is READY and books.js has opened what the URL asked for
   (an essay link, or JL1's Journal). Upright with nothing open, the Journal
   opens: portrait is the Journal. */
(function wait() {
  var B = window.RoomBooks;
  if (!window.__ready || !B || !B.resumeJournal) { setTimeout(wait, 80); return; }
  booted = true; cur = land();
  if (!cur && !openBook() && !termUp() && !world()) { H.classList.add('turning'); B.resumeJournal(); setTimeout(function () { H.classList.remove('turning'); }, 120); }
  classes();
})();
function watchBooks() {
  var mo = new MutationObserver(function () {
    if (stowed && stowed.getAttribute('data-open') !== 'true') stow(null);
    classes();
  });
  document.querySelectorAll('.book').forEach(function (b) {
    mo.observe(b, { attributes: true, attributeFilter: ['data-open'] });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBooks, { once: true });
else watchBooks();

/* a press made while a book is open is the book's (books.js puts it down,
   or goes back to the contents, on this same press, in its own capture
   listener); the engine reads this and lets the press go, so the map
   under a sideways book, or behind the Journal, does not move */
window.addEventListener('pointerdown', function (e) {
  if (openBook() || (termOut && e.target.closest && e.target.closest('.tm'))) {
    try { Object.defineProperty(e, '__phBook', { value: true }); } catch (err) { }
  }
}, { capture: true, passive: true });

/* ---- PH6: AN OPEN BOOK'S PAGE TURNS UNDER A SWIPE ------------------- */
/* A stroke to the left turns on, to the right turns back — to the left OF
   THE PAGE, so on the sideways book the stroke is turned into the frame's
   own axes. Not from the glass's side edges: iOS takes a stroke from the
   left edge as Back, and a page turned there would be the page left. */
var EDGE = 24;
var sw = null;
document.addEventListener('pointerdown', function (e) {
  var b = e.target.closest && e.target.closest('.book[data-open="true"]');
  var edge = e.clientX < EDGE || e.clientX > window.innerWidth - EDGE;
  sw = b && !edge ? { b: b, x: e.clientX, y: e.clientY, id: e.pointerId } : null;
}, true);
document.addEventListener('pointerup', function (e) {
  var s = sw; sw = null;
  if (!s || s.id !== e.pointerId) return;
  var dx = e.clientX - s.x, dy = e.clientY - s.y;
  if (sideBook()) {
    var t = dx;
    if (H.classList.contains('ccw')) { dx = -dy; dy = t; } else { dx = dy; dy = -t; }
  }
  if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
  var j = s.b.id === 'journal';
  var btn = document.getElementById((j ? 'journal-' : 'book-') + (dx < 0 ? 'next' : 'prev'));
  if (btn && !btn.hidden) btn.click();
}, true);

/* ==== PH10: A TAP IS A TAP, WHATEVER THE BROWSER MAKES OF IT ===========
   Tommy's iPhone: "I also couldn't click into any of the actual articles".
   The contents lines and the covers change the page on pointerenter (the
   hover lift), which iOS reads as a hover and answers with no click at
   all. So on the phone a press that does not travel and comes up within
   the moment is a TAP, decided here from where the finger was: on a spine,
   on a line of the contents, a page corner, the running head's links or
   the turn mark; and the thing is pressed once, here. The click the
   browser makes of the same tap, if it makes one, is let go unheard, so
   nothing is pressed twice. Everything else is the browser's as before. */
var tp = null, downs = new Set(), quiet = 0;
var efp = Document.prototype.elementFromPoint;
function at(px, py) { return efp.call(document, px, py); }
function press(el) { quiet = Date.now() + 700; el.click(); }
function tapAt(px, py) {
  var n = at(px, py), open = openBook();
  if (!n || !n.closest) return false;
  if (!open) {
    var cv = n.closest('.book-cover');
    if (cv && stowed && stowed.contains(cv)) { unstow(); quiet = Date.now() + 700; return true; }
    if (cv) { press(cv); return true; }
    var tm = n.closest('.tm');
    if (tm && !termOut && (cur || uproom) && termUp()) { primeKeys(); setTerm(true); quiet = Date.now() + 700; return true; }
    if (tm && termOut) { press(n.closest('button') || tm); return true; }
    return false;
  }
  if (!open.contains(n)) return false;
  var hit = n.closest('.journal-contents .jc-entry, .book-corner, .journal-margin, #journal-contents, #journal-no, .phone-turn');
  if (!hit || hit.hidden) return false;
  press(hit);
  return true;
}
window.addEventListener('pointerdown', function (e) {
  if (e.pointerType === 'mouse') return;
  downs.add(e.pointerId);
  /* `open`: a press that found a book open is that book's, even when the
     press itself put it down (a tap off the leaf, books.js) */
  tp = downs.size === 1 ? { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), open: !!openBook() } : null;
}, true);
window.addEventListener('pointerup', function (e) {
  if (e.pointerType === 'mouse') return;
  downs.delete(e.pointerId);
  var t = tp; tp = null;
  if (!t || t.id !== e.pointerId || Date.now() - t.t > 700) return;
  if (Math.hypot(e.clientX - t.x, e.clientY - t.y) > 10) return;
  if (t.open && !openBook()) return;
  tapAt(e.clientX, e.clientY);
}, true);
window.addEventListener('pointercancel', function (e) { downs.delete(e.pointerId); tp = null; }, true);
window.addEventListener('click', function (e) {
  if (e.isTrusted && Date.now() < quiet) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);

/* THE PAGE ITSELF NEVER ZOOMS OR SCROLLS UNDER A THUMB. The canvas has
   touch-action none; Safari's own pinch is a gesture event as well. The
   browser's own text size (Safari's and Chrome's menus) still reaches the
   Journal's prose. */
['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) {
  document.addEventListener(t, function (e) { e.preventDefault(); }, { passive: false });
});

window.RoomPhone = { land: function () { return cur; }, term: function () { return termOut; },
                    stowed: function () { return stowed; }, room: function () { return uproom; },
                    poke: poll,   /* UF1: engine.js, at the moment an unfold is let go */
                    primeKeys: primeKeys,   /* KB1: engine.js, the tap on the machine */
                    booksIn: booksIn,       /* JL1: books.js, the end of its init */
                    landSize: function () {
                      return landSize || [Math.max(screen.width, screen.height), Math.min(screen.width, screen.height)];
                    }, unstow: unstow, sideBook: sideBook, turned: function () { return false; },
                    page: function (e) { return [e.clientX, e.clientY]; } };
})();
